<script>
export default {}
</script>

<template>
  <div />
</template>

<style lang="scss" module>
@import '@design';
</style>
